import { render, staticRenderFns } from "./about-form.vue?vue&type=template&id=96f114b6&scoped=true&"
import script from "./about-form.vue?vue&type=script&lang=ts&"
export * from "./about-form.vue?vue&type=script&lang=ts&"
import style0 from "./about-form.vue?vue&type=style&index=0&id=96f114b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f114b6",
  null
  
)

export default component.exports